import { render } from "./OverviewBlocks.vue?vue&type=template&id=67fc5713"
import script from "./OverviewBlocks.vue?vue&type=script&lang=js"
export * from "./OverviewBlocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__